// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__S_Pka","frame":"Dialog_frame__3XaI8","closeButton":"Dialog_closeButton__1TQZw","okButton":"Dialog_okButton__2Pl7D","body":"Dialog_body__iLin2"};